import { useContext, useEffect, useState } from 'react';
import { Modal, SectionPreTitle, SectionTitle } from '../atoms';
import { APIEndPoints } from '../../apis';
import { EditUserAccountState } from './forms/EditUserAccountState';
import { EditUserAccountDetails } from './forms/EditUserAccountDetails';
import { EditUserEmail } from './forms/EditUserEmail';
import { EditUserMobile } from './forms/EditUserMobile';
import { EditUserRole } from './forms/EditUserRole';
import { SetUserPassword } from './forms/SetUserPassword';
import { UserContext } from '../../contexts';

type TUserCreationType = 'platform_user' | 'tenant_user';

type TEditUserModal = {
  modalTitle?: string;
  content?: any; //CAM TODO
  userType: TUserCreationType;
  isModalOpen: boolean;
  handleModalClose: () => void;
  refreshPage: () => void;
};

const EditUserModal = ({
  modalTitle,
  content,
  userType,
  isModalOpen,
  handleModalClose,
  refreshPage
}: TEditUserModal) => {
  const {
    userId,
    accountLocked,
    accountArchived,
    fullName,
    title,
    readOnly,
    pas,
    emailNotifications,
    email,
    mobile,
    role,
    merchantId // merchant id of user being edited
  } = content;
  const apiEndpoint =
    userType === 'platform_user'
      ? `${APIEndPoints.usersPlatform}/${userId}`
      : `${APIEndPoints.usersMerchant}/${merchantId}/${userId}`;
  const [shouldRefresh, setShouldRefresh] = useState<boolean>(false);
  const { user } = useContext(UserContext);
  const userMerchantId = user.merchantId; //merchant id of current user, not user being edited

  let status = null;

  if (accountArchived) {
    status = 'Archived';
  } else if (accountLocked) {
    status = 'Inactive';
  } else {
    status = 'Active';
  }

  useEffect(() => {
    if (isModalOpen === false && shouldRefresh === true) {
      refreshPage();
      setShouldRefresh(false);
    }
  }, [isModalOpen, refreshPage, shouldRefresh]);

  return (
    <Modal
      handleClose={handleModalClose}
      isModalVisible={isModalOpen}
      content={
        <>
          {modalTitle && <SectionPreTitle>{modalTitle}</SectionPreTitle>}
          <SectionTitle>{fullName}</SectionTitle>
          <EditUserAccountState
            status={status}
            isModalOpen={isModalOpen}
            apiEndpoint={apiEndpoint}
            refresh={{ shouldRefresh, setShouldRefresh }}
          />
          {/* only display for platform users */}
          {userMerchantId === 'PLATFORM' && (
            <SetUserPassword email={email} isModalOpen={isModalOpen} />
          )}
          <EditUserAccountDetails
            content={{ fullName, title, readOnly, pas, emailNotifications }}
            userType={userType}
            isModalOpen={isModalOpen}
            apiEndpoint={apiEndpoint}
            refresh={{ shouldRefresh, setShouldRefresh }}
          />
          <EditUserEmail
            email={email}
            isModalOpen={isModalOpen}
            apiEndpoint={`${apiEndpoint}/email`}
            refresh={{ shouldRefresh, setShouldRefresh }}
          />
          <EditUserMobile
            mobile={mobile}
            isModalOpen={isModalOpen}
            apiEndpoint={`${apiEndpoint}/mobile`}
            refresh={{ shouldRefresh, setShouldRefresh }}
          />

          {userType === 'tenant_user' && (
            <EditUserRole
              role={role}
              isModalOpen={isModalOpen}
              apiEndpoint={`${apiEndpoint}/role`}
              refresh={{ shouldRefresh, setShouldRefresh }}
            />
          )}
        </>
      }
    />
  );
};

export { EditUserModal };
